import { createAction, props } from '@ngrx/store';

export const loadP2PCampaignList = createAction(
  '[Campaign] Load loadP2PCampaignList',
  props<any>()
);

export const loadP2PCampaignListSuccess = createAction(
  '[Campaign] Load loadP2PCampaignList Success',
  props<{ data: any }>()
);

export const loadP2PCampaignListFailure = createAction(
  '[Campaign] Load loadP2PCampaignList Failure',
  props<{ error: any }>()
);

export const selectP2PCampaign = createAction(
  '[Campaign] Load selectP2PCampaign',
  props<any>()
);

export const selectP2PCampaignSuccess = createAction(
  '[Campaign] Load selectP2PCampaign Success',
  props<{ data: any }>()
);

export const selectP2PCampaignFailure = createAction(
  '[Campaign] Load selectP2PCampaign Failure',
  props<{ error: any }>()
);

export const peerToPeerReport = createAction(
  '[Campaign] Load PeerToPeerReport',
  props<any>()
);

export const peerToPeerReportSuccess = createAction(
  '[Campaign] Load PeerToPeerReport Success',
  props<{ data: any }>()
);

export const peerToPeerReportFailure = createAction(
  '[Campaign] Load PeerToPeerReport Failure',
  props<{ error: any }>()
);

export const peerToPeerInfo = createAction(
  '[Campaign] Load peerToPeerInfo',
  props<any>()
);

export const peerToPeerInfoSuccess = createAction(
  '[Campaign] Load peerToPeerInfo Success',
  props<{ data: any }>()
);

export const peerToPeerInfoFailure = createAction(
  '[Campaign] Load peerToPeerInfo Failure',
  props<{ error: any }>()
);

export const addP2PDonation = createAction(
  '[Campaign] Load AddP2PDonation',
  props<any>()
);

export const addP2PDonationSuccess = createAction(
  '[Campaign] Load AddP2PDonation Success',
  props<{ data: any }>()
);

export const addP2PDonationFailure = createAction(
  '[Campaign] Load AddP2PDonation Failure',
  props<{ error: any }>()
);

export const updateP2P = createAction(
  '[Campaign] Load UpdateP2P',
  props<any>()
);

export const updateP2PSuccess = createAction(
  '[Campaign] Load UpdateP2P Success',
  props<{ data: any }>()
);

export const updateP2PFailure = createAction(
  '[Campaign] Load UpdateP2P Failure',
  props<{ error: any }>()
);

export const deleteP2PItem = createAction(
  '[Campaign] Load DeleteP2PItem',
  props<any>()
);

export const deleteP2PItemSuccess = createAction(
  '[Campaign] Load DeleteP2PItem Success',
  props<{ data: any }>()
);

export const deleteP2PItemFailure = createAction(
  '[Campaign] Load DeleteP2PItem Failure',
  props<{ error: any }>()
);

export const deleteP2PPledge = createAction(
  '[Campaign] Load DeleteP2PPledge',
  props<any>()
);

export const deleteP2PPledgeSuccess = createAction(
  '[Campaign] Load DeleteP2PPledge Success',
  props<{ data: any }>()
);

export const deleteP2PPledgeFailure = createAction(
  '[Campaign] Load DeleteP2PPledge Failure',
  props<{ error: any }>()
);

export const saveP2PEventCount = createAction(
  '[Campaign] Load saveP2PEventCount',
  props<any>()
);

export const saveP2PEventCountSuccess = createAction(
  '[Campaign] Load saveP2PEventCount Success',
  props<{ data: any }>()
);

export const saveP2PEventCountFailure = createAction(
  '[Campaign] Load saveP2PEventCount Failure',
  props<{ error: any }>()
);